import tw from 'twin.macro';
import styled from 'styled-components';

const Heading3 = styled.h3(() => [tw`text-3xl md:text-4xl mt-7 mb-5 font-semibold`]);

export default Heading3;
